import React, { useEffect, useState, useRef, useCallback } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"

import { Typography, Box, Tabs, Tab } from "@mui/material";
import { RecentActors } from "@mui/icons-material";
import { FlexGrid, Card, Link, Button } from '@albo-ui/core'
import CustomPagination from "../elements/CustomPagination";
import { useCatalog } from "../../util/hooks/useCatalog";
import { ManualCheckService } from "../../services/ManualCheckService";
import { CustomerValidate } from "../modals/manualcheck/CustomerValidate";


const WaitingAuthList = (props) => {
    const manualCheckService = useRef<ManualCheckService>();

    const history = useHistory();
    const [data, setData] = useState([]);
    const [statusCatalog] = useCatalog("abb_status_lead", props.changeAlert);

    const [flag, setFlag] = useState(null);
    const [lead, setLead] = useState(null);
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(false);
    const [page, setPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(5);
    const [tabActive, setTabActive] = useState("retail");
    const [tabs] = useState([
        {key: "retail", title: "Retail" },
        {key: "afb", title: "albo Empresa" },
    ]);

    useEffect(() => {
        if (props.update) {
            initCLevel(props.page);
            props.changeUpdate(0);
        }
        if(props.widgets[0]["tabActive"]){
            setActive(true);
            setTabActive(props.widgets[0]["tabActive"])
        }
        setPage(props.page);
        setData(JSON.parse(JSON.stringify(props.content)));
        manualCheckService.current = new ManualCheckService(props.changeAlert);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.update, props.content]);

    const colapse = () => {
        if (!active) {
        setActive(true);
        } else {
        setActive(false);
        }
    };

    const hasAction = (action) => {
      return props.config?.actions?.indexOf(action) > -1;
    };

    const initCLevel = async (page, rows= rowsPerPage) => {
        props.changeLoader(true);
        let data = {
            limit: rows,
            page: page
        }

        let widgetsCompliance = await API.service( "initCLevel", data, props.pos, props.changeAlert, props.changeLoader, history );
        if (widgetsCompliance.status === 200 &&  widgetsCompliance.data.data.response === "OK" ) {
            let res = widgetsCompliance.data.data.widget[0]
            setData(res.content);
            setPage(res.page);
        }
        props.changeLoader(false);
    };

    
    const getCLevel = async (page, rows= rowsPerPage) => {
        props.changeLoader(true);
        let data = {
            limit: rows,
            page: page
        }

        let request = await API.service( "initCLevel", data, props.pos, props.changeAlert, props.changeLoader, history );
        if (request.status === 200 &&  request.data.data.response === "OK" ) {
            await props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
        props.changeLoader(false);
    };

    
    const afbClevelList = async (page, rows= rowsPerPage) => {
        props.changeLoader(true);
        setData([]);

        let payload = {
            status: "assigned",
            limit: rows,
            page: page
        }

        let request = await API.service( "afbClevelList", payload, props.pos, props.changeAlert, props.changeLoader, history );
        if (request.status === 200 &&  request.data.data.response === "OK" ) {
            await props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }

        props.changeLoader(false);

    };

    const changeSelected = async (uuid, index) => {
        props.changeLoader(true);
        if(hasAction("clevelRisk")){
            await props.newWidgets("infoPersonalCLevel", uuid);
        } else {
            await props.newWidgets("infoPersonalCompliance", uuid);
        }
        props.changeLoader(false);
    };

    const onHandleChange = (lead, flag) => {
        setLead(lead); 
        setFlag(flag); 
        setOpen(true);
    }
    const onClose =  () => {
        setOpen(false)
    }

    const handleSectionChange = useCallback( async (lead) => {
        props.widgets[0]["tabActive"] = tabActive

        const widget = {
            type: 'leadsOnboardingSections',
            data: lead.lead,
            config: props.config,
            widgets: props.widgets
        }
        return props.changeWidgets([widget])
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props])

    // ----------------------------------------------------------  
    const getStatus = (lead) => {
        const status = statusCatalog?.find(s => s.name === lead.status);
        return status ? status["metadata"]["description"] : lead.status;
    }

    const columns = [
        {
            cell: (item, index) => {
                return (
                    <Link onClick={changeSelected.bind(this, item.uuid, index)}>
                        <VisibilityIcon />
                    </Link>
                );
            },
            width: "10%", sortable: true,
        },
        { selector: (row) => row.name, name: "Nombre", width: "30%", sortable: true },
        { selector: (row) => row.email, name: "Email", width: "30%", sortable: true },
        { selector: (row) => row.statusParse, name: "Estatus", width: "15%", sortable: true },
        { selector: (row) => row.risk_level, name: "Nivel de riesgo", width: "15%", sortable: true },
    ];

    const afbColumns = [
        { cell: (item, index) => {
            return <Link onClick={handleSectionChange.bind(this, item)}><VisibilityIcon /></Link>;
          }, width: "4%", sortable: true,
        },
        { selector: (row) => row["lead"].social_reason, name: "Razón Social", sortable: true, wrap: true },
        { selector: (row) => row["lead"].email, name: "Email", sortable: true, wrap: true  },
        { selector: (row) => getStatus(row["lead"]), name: "Estatus", width: "10%", sortable: true, wrap: true  },
        { selector: (row) => row["lead"].risk_level, name: "Riesgo", width: "8%", sortable: true, wrap: true  },
        { selector: (row) => row["reason_request"] || "Sin comentarios", name: "Motivo",  width: "15%", sortable: true, wrap: true },
        { cell: (row) => {
            return <FlexGrid container spacing={2} style={{paddingBlock: 10}}>
                <Button onClick={onHandleChange.bind(this, row, "rejected")} buttonType="warning" color="sunset" size="small" style={{ width: 120}}>Rechazar</Button>
                <Button onClick={onHandleChange.bind(this, row, "approved")} buttonType="secondary" size="small" style={{ width: 120}}>Aprobar</Button>
            </FlexGrid>
        }, name: "Aprobación", width: "23%", sortable: true },
    ];

	const changePage = (action, page, rows= rowsPerPage) => {
		setPage(page+1);
        initCLevel(page+1, rows)
	}

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
		changePage(null, 0, parseInt(event.target.value, 10));
	};

    function findActiveTab(item) { 
        return item.key === tabActive;
    };
    const changeTab = (tab: string) => {
        setTabActive(tab);
        return tab === "afb" ? afbClevelList(1) : getCLevel(1);
    };

    return (
		<Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: "white", marginBottom: 15}}> 
			<FlexGrid container fullWidth justify="space-between">
				<FlexGrid item>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}} fontWeight={600}>
						<RecentActors sx={{ marginRight: 1 }}/>  {hasAction("clevelRisk") ? "Aprobación de Clientes de alto riesgo" : "Validación deeeee Identidad"}
					</Typography>
				</FlexGrid>
				<FlexGrid container justify="flex-end" alignItems='center' spacing={1}>
                    <Link onClick={colapse} bold typography="smallTitle">
                        {!active ? "Ver listado" : "Ocultar listado"}
                    </Link>
				</FlexGrid>
			</FlexGrid>
            {active && 
                <>
                { hasAction("clevelRisk") && <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={data.length > 0 ? 2 : 10} mt={5}>
                    <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' centered >
                        {tabs.map((item, index) => {
                            return (
                                <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.key)} sx={{margin: 'auto', textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18, width: "50%", maxWidth: "initial"}}/>
                            );
                        })}
                    </Tabs>
                </Box>}
                <ThemeProvider theme={theme}>
                    <DataTable
                        columns={tabActive === "afb" ? afbColumns : columns}
                        data={data}
                        customStyles={customStyles}
                        noDataComponent={noDataComponent}
                    />
                </ThemeProvider>
                <CustomPagination 
                    rows={props.total}
                    page={page - 1}
                    rowsPerPage={rowsPerPage}
                    handleChangePage={changePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
                <CustomerValidate
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    afbClevelList={afbClevelList}
                    onClose={onClose}
                    open={open}
                    lead={lead}
                    flag={flag}          
                />
                </>
            }
        </Card>
    )
};

export default WaitingAuthList;